import React from 'react'
import WhatsAppIcon from './WhatsAppIcon'
import houseLogo from '../../assets/icons/house_logo.svg'

function ArrowRight() {
  return (
    <svg className="ml-auto shrink-0" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  )
}

function ActionCard({ href, onClose, children }) {
  return (
    <div className="mx-3 rounded-2xl bg-white shadow-[0_2px_16px_rgba(0,0,0,0.10)] overflow-hidden">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}
        className="flex items-center gap-2 py-4 px-4 w-full text-[13px] font-semibold text-woperty-teal no-underline hover:no-underline hover:text-woperty-teal hover:bg-woperty-teal-light transition-colors duration-150"
      >
        <WhatsAppIcon className="w-4 h-4 shrink-0" />
        {children}
        <ArrowRight />
      </a>
    </div>
  )
}

export default function WhatsAppModal({ onClose, waArrendatario, waPropietario }) {
  return (
    <div className="w-[19rem] rounded-2xl shadow-2xl overflow-hidden bg-white flex flex-col">
      {/* Header */}
      <div className="px-4 pt-4 pb-6 bg-white">
        <div className="mb-3">
          <img src={houseLogo} alt="" aria-hidden="true" className="w-8 h-8" />
        </div>
        <h2 className="text-[22px] font-bold text-gray-900 leading-tight">Hola 👋</h2>
        <p className="mt-1 text-[15px] text-gray-500 leading-snug">
          Envíanos un mensaje
        </p>
      </div>

      {/* Spacer */}
      <div className="flex-1 min-h-[80px] bg-gray-50" />

      {/* Action cards */}
      <div className="-mt-6 mb-2 flex flex-col gap-3">
        {waArrendatario && (
          <ActionCard href={waArrendatario} onClose={onClose}>
            Soy arrendatario
          </ActionCard>
        )}
        {waPropietario && (
          <ActionCard href={waPropietario} onClose={onClose}>
            Soy propietario
          </ActionCard>
        )}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-center gap-1.5 pt-2 pb-3">
        <WhatsAppIcon className="w-3.5 h-3.5 text-gray-400" />
        <span className="text-[11px] text-gray-400">Contacto por WhatsApp</span>
      </div>
    </div>
  )
}
